<template>
    <div class="item-notification" :class="{ 'no-image' : thumbnail === '' }">
        <div class="image" v-if="thumbnail !== ''">
            <ion-img :src="thumbnail" :alt="title" />
        </div>
        <div class="description">
            <div class="status" :class="isRead === false ? 'active' : 'closed'">
                <span class="dot"><svg width="20" height="20" viewBox="0 0 20 20"><circle cx="10" cy="10" r="4.5" /></svg></span>
                <span class="label" v-text="isRead === false ? 'Nowa' : 'Przeczytana'"></span>
                <div v-if="loading" class="loader-wrapper smaller"><span class="loader red"></span></div>
                <span class="close" v-if="isRead === false && loading === false" @click="dismissNotification(slug)"><svg class="voxion"><use :xlink:href="'#icon-close'"></use></svg></span>
            </div>
            <div v-if="redirect">
                <span @click="goTo(redirect, slug)" class="pointer">
                    <div class="title text-bold">{{ title }}</div>
                    <div class="content" v-html="content"></div>
                </span>
            </div>
            <div v-else>
                <div class="title text-bold">{{ title }}</div>
                <div class="content" v-html="content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '@/services/Api';

    export default {
        name: 'ItemNotification',
        props: ['slug', 'title', 'content', 'thumbnail', 'isRead', 'redirect'],
        data(){
            return{
                loading: false
            }
        },
        computed: {
            ...mapGetters(['getNotifications'])
        },
        methods: {
            dismissNotification: function (slug) {
                this.loading = true;
                api.post('/api/v1/notifications/'+slug+'/update').then(response => {
                    if(response.data.code === 200){
                        this.loading = false;
                        let index = this.getNotifications.map(function(item){
                            return item.slug
                        }).indexOf(slug);
                        let value = {
                            index : index,
                            bool : true
                        };
                        this.$store.commit('USER_DISMISS_NOTIFICATION', value)
                        this.$gtag.event('notification', 'Dismiss Notification')
                    }
                })
            },
            goTo: function (redirect, slug) {
                this.dismissNotification(slug)
                this.$router.push(redirect)
            }
        },
    }
</script>